import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full p-3 rounded-md overflow-scroll gap-3 border border-gray-400 mt-8 flex justify-start items-start flex-col text-left" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"text-sm font-semibold\">Read History</div><div class=\"grid grid-cols-6 overflow-scroll sx:w-[700px] w-full text-sm\"><div class=\"px-2 py-1 bg-[#ffcdef56] rounded-md h-fit w-fit\"> Book Title </div><div class=\"px-2 py-1 bg-[#ffcdef56] rounded-md h-fit w-fit\"> Book Author </div><div class=\"px-2 py-1 bg-[#ffcdef56] rounded-md h-fit w-fit\"> Book Genre </div><div class=\"px-2 py-1 bg-[#ffcdef56] rounded-md h-fit w-fit\"> Book Pages </div><div class=\"px-1 py-1 bg-[#ffcdef56] rounded-md h-fit w-fit\">Props</div><div class=\"px-1 py-1 bg-[#ffcdef56] rounded-md h-fit w-fit\">Status</div></div>", 2)
const _hoisted_4 = {
  key: 0,
  class: "w-full sx:w-[700px] overflow-scroll"
}
const _hoisted_5 = { class: "px-2" }
const _hoisted_6 = { class: "px-2" }
const _hoisted_7 = { class: "px-2" }
const _hoisted_8 = { class: "px-2" }
const _hoisted_9 = { class: "px-1" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "px-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 443.57 607.17",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "296.07",
      cy: "186.91",
      r: "68.31",
      fill: "#00f24c"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "m277.9,388.33c3.53,6.91,7.06,13.83,10.59,20.74,1.01,1.99,3.98,1.36,4.57-.6,4.63-15.44,13.23-29.51,24.82-40.7,2.32-2.24-1.22-5.77-3.54-3.54-12.2,11.78-21.23,26.67-26.11,42.91l4.57-.6c-3.53-6.91-7.06-13.83-10.59-20.74-1.46-2.87-5.78-.34-4.32,2.52h0Z",
      fill: "#fff"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 443.57 607.17",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "296.07",
      cy: "186.91",
      r: "68.31",
      fill: "#870000"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "m277.9,388.33c3.53,6.91,7.06,13.83,10.59,20.74,1.01,1.99,3.98,1.36,4.57-.6,4.63-15.44,13.23-29.51,24.82-40.7,2.32-2.24-1.22-5.77-3.54-3.54-12.2,11.78-21.23,26.67-26.11,42.91l4.57-.6c-3.53-6.91-7.06-13.83-10.59-20.74-1.46-2.87-5.78-.34-4.32,2.52h0Z",
      fill: "#fff"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "flex justify-center items-center text-sm"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "You have no book in your read history. Add books to get started.", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "" }, " Enter Book Details Below to keep track of your Adventure ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", {
  class: "rounded-sm px-4 py-2 font-medium bg-boxColor text-white text-sm outline-none hover:shadow-typeBox",
  type: "submit"
}, " Add Book ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($options.booksData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.booksData, (books) => {
            return (_openBlock(), _createElementBlock("div", {
              key: books.id,
              class: "grid grid-cols-6 mt-3 w-full text-sm"
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(books.bookTitle), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(books.bookAuthor), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(books.bookGenre), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(books.bookPages), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: "cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = $event => ($data.displayModal = true))
                }, [
                  _createElementVNode("button", {
                    onClick: $event => ($options.editBooks(books._id))
                  }, "Edit", 8, _hoisted_10)
                ]),
                _createTextVNode(" / "),
                _createElementVNode("span", {
                  class: "cursor-pointer",
                  onClick: $event => ($options.removeCurrentBook(books._id))
                }, "Delete", 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (books.completed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_18))
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)),
    _createVNode(_component_Card, {
      "display-modal": $data.displayModal,
      "onUpdate:displayModal": _cache[6] || (_cache[6] = $event => ($data.displayModal = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers((...args) => ($options.updateBook && $options.updateBook(...args)), ["prevent"])),
          class: "flex flex-col w-auto gap-y-3 bg-white shadow-typeBox px-4 py-6 rounded-md"
        }, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($options.bookTitle) = $event)),
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
            type: "text",
            placeholder: "Book title e.g purple hibiscus"
          }, null, 512), [
            [_vModelText, $options.bookTitle]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.bookAuthor) = $event)),
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
            type: "text",
            placeholder: "Author e.g chimamanda adichie"
          }, null, 512), [
            [_vModelText, $options.bookAuthor]
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm",
            type: "text",
            placeholder: "Book Genre",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($options.bookGenre) = $event))
          }, null, 512), [
            [_vModelText, $options.bookGenre]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($options.bookPages) = $event)),
            placeholder: "Total pages",
            class: "w-full bg-transparent border border-gray-400 text-black outline-none p-2 rounded-sm"
          }, null, 512), [
            [_vModelText, $options.bookPages]
          ]),
          _hoisted_23
        ], 32)
      ]),
      _: 1
    }, 8, ["display-modal"])
  ]))
}